import { GrouperData } from 'src/contracts/grouperData';
import { ProcedureCode } from 'src/contracts/procedureCode';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { fromPOAValue } from 'src/contracts/poa';

export class GrouperServiceConverter {

  public static convertGrouperData(response: any): GrouperData {
    return {
      diagnosisCodes: this.getDiagnosisCodes(response),
      procedureCodes: this.getProcedureCodes(response)
    };
  }

  private static getProcedureCodes(response: any): ProcedureCode[] {
    if (!response || !response['procedures']) {
      return [];
    }

    return response['procedures'].map((procedure: any) => {
      return <ProcedureCode>{
        id: procedure['position'],
        code: procedure['code'],
        action: undefined,
        description: procedure['description'],
        slot: [],
        impact: []
      }
    })
  }

  private static getDiagnosisCodes(response: any): DiagnosisCode[] {
    if (!response || !response['diagnoses']) {
      return [];
    }

    return response['diagnoses'].map((diagnosis: any) => {
      return <DiagnosisCode>{
        id: diagnosis['position'],
        code: diagnosis['code'],
        action: undefined,
        description: diagnosis['description'],
        pdx: [],
        drgModifier: [],
        poa: fromPOAValue(diagnosis['poa']),
        quality: [],
        risk: [],
      }
    })
  }
}
